import React, { Component } from 'react';
import moment from 'moment-timezone';
import { Trans, translate } from 'react-i18next';

class Summary extends Component {

  horarioSala = (start, end) => {
    return (
      <div className="panel-body">
        {start + " - " + end}
      </div>
    )
  }

  render() {
    const reservation = this.props.RoomBook
    const paymentDetails = this.props.paymentDetails
    const count = this.props.count ? this.props.count.capacidad : null
    const endDate = moment(reservation.fecha_final, 'YYYY-MM-DD HH:mm:ss');
    const startDate = moment(reservation.fecha_inicial, 'YYYY-MM-DD HH:mm:ss');
    const { t } = this.props;

    return (
      <div className="card-panel panel panel-default card">
        <div className="panel-heading-text">
          <h4 className="panel-title">{t('dashboard.room_payment.heading_summary')}</h4>
        </div>
        <div className="panel-heading" style={{ backgroundImage: "url('" + reservation.nombre_imagen + "')" }}>
        </div>
        <div className="panel-body">
          <div className="contenedor-flexbox">
            <div className="contenedor">
              <i className="fa fa-map-marker" aria-hidden="true"></i>
              {" "}{reservation.name}
            </div>
            <div className="contenedor">
              <i className="fa fa-users" aria-hidden="true">
              </i>
              {" "}Capacidad para {count} personas.
            </div>
            <div className="contenedor">
              <i className="fa fa-calendar" aria-hidden="true"></i>
              {" "}{startDate.format('ll')}
            </div>
            <div className="contenedor">
              <i className="fa fa-clock-o" aria-hidden="true"></i>
              {" "}{startDate.format('HH:mm')} - {endDate.format('HH:mm')}
            </div>
            {/* <div className="contenedor">
              <i className="fa fa-building-o" aria-hidden="true"></i>
              {" "}{this.props.center.name}
            </div> */}
          </div>
          {paymentDetails ? (
            <div className={"panel-footer"}>
              <div className="contenedor-flexbox-card">
                <div className="col-xs-6">
                  <p>{t('dashboard.room_payment.subtotal')}</p>
                </div>
                <div className="col-xs-6 text-primary">
                  <p>{"$" + Number(paymentDetails.subtotal).toFixed(2) + " " + paymentDetails.currency}</p>
                </div>
                <div className="col-xs-6">
                  <p>{t('dashboard.room_payment.discount')}</p>
                </div>
                <div className="col-xs-6 text-primary">
                  <p>{"$" + Number(paymentDetails.credits).toFixed(2) + " " + paymentDetails.currency}</p>
                </div>
                <div className="col-xs-6">
                  <p>{t('dashboard.room_payment.iva')}</p>
                </div>
                <div className="col-xs-6 text-primary">
                  <p>{"$" + Number(paymentDetails.iva).toFixed(2) + " " + paymentDetails.currency}</p>
                </div>
                <div className="col-xs-6">
                  <p><strong>{t('dashboard.room_payment.total')}</strong></p>
                </div>
                <div className="col-xs-6 text-primary">
                  <p><strong>{"$" + Number(paymentDetails.total).toFixed(2) + " " + paymentDetails.currency}</strong></p>
                </div>
              </div>
              {/* <div className="form-group text-center">
                <button className="btn btn-primary btn-singup btn-resvations" onClick={this.props.handlePromocodeClick}>PROMOCODE</button>
              </div> */}
            </div>
          ) : null}
        </div>

      </div>
    );
  }
}

export default translate('common')(Summary);



// WEBPACK FOOTER //
// ./src/dashboard/store/Payment/Summary.js